import axios from "axios";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { API_ERROR_500 } from "../../../../config";
import { getStageScreen, setLoading } from "../../../../redux";
import Button from "../../components/Button";
import Label from "../../components/Label";
import TextInput from "../../components/TextInput";
import Title from "../../components/Title";

const NonDepositoryParticipant = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);
  const { inputLabelColor, inputError } = useSelector((state) => state.theme);
  const [dematAccountNumber, setDematAccountNumber] = useState("");
  const [documentProof, setDocumentProof] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const submit = async () => {
    setSubmitted(true);
    if (!documentProof && dematAccountNumber.length != 16) {
      return;
    }
    dispatch(setLoading(true));
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };

    // const resizedFile = await resizeFile(dpcumentProof);

    let formData = new FormData();
    documentProof && formData.append("document_proof", documentProof);
    formData.append("file_type", "Image");
    formData.append("demat_account_number", dematAccountNumber);
    axios
      .post(
        `${API_URL}/api/method/kyc_customizations.apis.non_depository_participant_details.api.update_nondp_details_in_kyc`,
        formData,
        headers
      )
      .then(() => {
        toast.success("Details saved successfully.");
        dispatch(getStageScreen());
        dispatch(setLoading(false));
      })
      .catch((error) => {
        const { response } = error;
        if (response?.data?.message) {
          toast.error(response?.data?.message);
        } else {
          toast.error(API_ERROR_500);
        }
        dispatch(setLoading(false));
      });
  };

  const uploadDocumentProof = (e) => {
    if (e.target.files.length == 0) {
      setDocumentProof(null);
    } else {
      setDocumentProof(e.target.files[0]);
    }
  };

  return (
    <React.Fragment>
      <Title title="Non Depository Participant" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-4">
              <TextInput
                label="Demat account number*"
                name="demat_account_number"
                placeholder="demat_account_number"
                value={dematAccountNumber}
                onChange={(e) => setDematAccountNumber(e.target.value)}
                error={
                  submitted && dematAccountNumber.length != 16
                    ? "Please enter valid 16 character demat account number"
                    : ""
                }
              />
            </div>
            <div className="mb-3">
              <div className="form-group">
                <Label label="Document proof*" />
                {/* <label style={{ color: inputLabelColor }}>Document proof</label> */}
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={uploadDocumentProof}
                />
                {submitted && !documentProof && (
                  <div style={{ color: inputError, fontSize: 10 }}>
                    Please upload your document
                  </div>
                )}
              </div>
            </div>
            <Button
              title="Submit"
              type="button"
              name="Submit"
              handleClick={() => submit()}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NonDepositoryParticipant;
